import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import Markdown from 'markdown-to-jsx';
import Sidebar from "react-sidebar";
import localStorageService from './components/localStorageService';

const styles = {
  sidebar: {
    width: 256,
    minHeight: "100%"
  },
  sidebarLink: {
    display: "block",
    padding: "16px 0px",
    color: "#757575",
    textDecoration: "none",
    border:0,
    backgroundColor:'white',
    textAlign:'left'
  },
  sidebarLinkInner: {
    display: "block",
    padding: "16px 0px",
    color: "#757575",
    textDecoration: "none",
    border:0,
    backgroundColor:'white',
    textAlign:'left',
    marginLeft:'10px'
  },
  divider: {
    margin: "8px 0",
    height: 1,
    backgroundColor: "#757575"
  },
  content: {
    padding: "16px",
    height: "100%",
    backgroundColor: "white"
  }
};


function Docs(props) {

  const style = props.style
    ? { ...styles.sidebar, ...props.style }
    : styles.sidebar;

  const [docs, setDocs] = useState('');
  const [markdown, setMarkdown] = useState('');
  let [content, setContent] = useState({ md: null });
  const [navData, setNavData] = useState([]);

  useEffect(() => {
   if(!localStorageService.getItem("loading")){
    localStorageService.setItem("loading",true)
    window.location.reload();
    
   }
    fetchData(localStorageService.getItem("mdfile"));
    getNavData();

  }, [])

  
  async function fetchData(docName) {
    fetch('docs/' + docName,
      {
        headers: {
          'Content-Type': 'application/vnd.github.v3+md',
          'Accept': 'application/vnd.github.v3+md'
        }
      })
      .then((res) => res.text())
      .then((md) => {

        setContent({ md })
      })

  }

  const getNavData = () => {
    fetch('sidenav.json'
      , {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    )
      .then(function (response) {
        // setData(response);
        return response.json();
      })
      .then(function (myJson) {
        console.log(myJson);
        setNavData(myJson.docs);
        
        return myJson
      });
  }

  

  return (
    <div>
      <Sidebar
        sidebar={
          <div style={style}>
            <div style={styles.content}>
              <a href="/OnBoardXR_Landing_Page" style={styles.sidebarLink}>
                Home
              </a>
             
              <div style={styles.divider} />
              { navData && navData.map((data,key)=>{
                return (
                  <>
                    <dl key={key} style={styles.sidebarLink}>
                      <dt >{data.mainCategory}</dt>
                      <dd>
                      { 
                        data.subCategories.map((innerData,innerKey)=>{

                          return <button key={innerKey} onClick={()=>{fetchData(innerData+'.md'); localStorageService.setItem("mdfile",innerData+".md")}} style={styles.sidebarLinkInner}>{innerData}</button>
                        })
                        
                      }
                      </dd>
                  </dl>
                </>
                )
              })}
            
             
            </div>
          </div>
        }
        open={true}
        docked={true}
        styles={{
          content: {
            padding: "16px"
          }
        }}
      >
        <Container>
          <div style={{ marginTop: '20px', marginBottom: '20px' }}>

          </div>
          {content.md !== null && <Markdown children={content.md} />}
        </Container>
      </Sidebar>
    </div>
  )
}

export default Docs